import React from "react";
import {Carousel} from "react-responsive-carousel";
import coverImg2 from "../../../../../assets/img/revamp/edulab/web-new-cover.jpg";
import coverImg3 from "../../../../../assets/img/institute/Banner Desktop-1.png";
import coverImg from "../../../../../assets/img/revamp/coverImg01.png";
import coverMobile01 from "../../../../../assets/img/revamp/edulab/mob-new-cover.jpg";
import coverMobile02 from "../../../../../assets/img/institute/Banner Mobile-1.png";
import d1 from "../../../../../assets/img/revamp/vibernets/landing/D1.jpg";
import d2 from "../../../../../assets/img/revamp/vibernets/landing/D2.jpg";
import d3 from "../../../../../assets/img/revamp/vibernets/landing/D3.jpg";
import d4 from "../../../../../assets/img/revamp/vibernets/landing/D4.jpg";
import m1 from "../../../../../assets/img/revamp/vibernets/landing/M1.jpg";
import m2 from "../../../../../assets/img/revamp/vibernets/landing/M2.jpg";
import m3 from "../../../../../assets/img/revamp/vibernets/landing/M3.jpg";
import m4 from "../../../../../assets/img/revamp/vibernets/landing/M4.jpg";
import '../version01.scss'

class HomeView extends React.Component {

    state = {
        screenSize: 1440,
    };

    componentDidMount() {
        this.setState({screenSize: window.innerWidth});
    }

    render() {
        console.log(this.props ? this.props : 'no')
        let {screenSize} = this.state;
        return (
            <div className={'version01'} id={"home"}>
                {screenSize > 425 ? <div className={'layoutSlider-view'}>
                        <Carousel showIndicators={false} autoPlay showThumbs={false}>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg} />*/}
                                <img className={"slideshow-pro-image"} src={d1}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg} />*/}
                                <img className={"slideshow-pro-image"} src={d2}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg} />*/}
                                <img className={"slideshow-pro-image"} src={d3}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg} />*/}
                                <img className={"slideshow-pro-image"} src={d4}/>
                            </div>
                        </Carousel>
                    </div> :

                    <div className={'layoutSlider-mobile-view'}>
                        <Carousel showIndicators={false} autoPlay showThumbs={false}>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg} />*/}
                                <img className={"slideshow-pro-image"} src={m1}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg}/>*/}
                                <img className={"slideshow-pro-image"} src={m2}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg}/>*/}
                                <img className={"slideshow-pro-image"} src={m3}/>
                            </div>
                            <div>
                                {/*<img className={"blur-img"} src={coverImg}/>*/}
                                <img className={"slideshow-pro-image"} src={m4}/>
                            </div>

                        </Carousel>
                    </div>

                }
            </div>
        )
    }

}

export default HomeView;
